import { createSelector } from 'reselect';
import { APP_ACTION_TYPES } from '../../config';

export const appStateSelector = (state) => state[APP_ACTION_TYPES.PREFIX];

export const getAuth = createSelector(appStateSelector, (appState) => appState.authState);
